module.exports = __webpack_public_path__ + "static/waterdispensers-b2dda70712f5a24121ac8211af236a73.jpg";